import React, { useState, useEffect } from 'react';
import { activityAPI } from '../services/api';
import { format } from 'date-fns';

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    action: ''
  });

  useEffect(() => {
    fetchLogs();
  }, [filters]);

  const fetchLogs = async () => {
    try {
      const response = await activityAPI.list(filters);
      setLogs(response.data.results || response.data);
    } catch (err) {
      console.error('Failed to fetch activity logs:', err);
    } finally {
      setLoading(false);
    }
  };

  const getActionBadge = (action) => {
    const colors = {
      login: 'success',
      logout: 'gray',
      create_license: 'success',
      revoke_license: 'danger',
      extend_license: 'warning',
      create_customer: 'success',
      update_customer: 'warning',
      delete_customer: 'danger'
    };
    return <span className={`badge badge-${colors[action] || 'gray'}`}>{action.replace(/_/g, ' ')}</span>;
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Activity Logs</h1>
          <p className="page-description">Track admin user activities</p>
        </div>
      </div>

      <div className="card">
        {/* Filters */}
        <div style={{ marginBottom: '1.5rem' }}>
          <select
            className="form-select"
            style={{ width: 'auto' }}
            value={filters.action}
            onChange={(e) => setFilters({ ...filters, action: e.target.value })}
          >
            <option value="">All Actions</option>
            <option value="login">Login</option>
            <option value="logout">Logout</option>
            <option value="create_license">Create License</option>
            <option value="revoke_license">Revoke License</option>
            <option value="extend_license">Extend License</option>
            <option value="create_customer">Create Customer</option>
            <option value="update_customer">Update Customer</option>
            <option value="delete_customer">Delete Customer</option>
          </select>
        </div>

        {loading ? (
          <div className="loading-container"><div className="spinner"></div></div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Action</th>
                  <th>Description</th>
                  <th>IP Address</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>
                      <div>
                        <span className="font-medium">{log.user_name || 'Unknown'}</span>
                        <br />
                        <small style={{ color: 'var(--gray-500)' }}>{log.user_email}</small>
                      </div>
                    </td>
                    <td>{getActionBadge(log.action)}</td>
                    <td style={{ maxWidth: '300px' }}>{log.description}</td>
                    <td>{log.ip_address || 'N/A'}</td>
                    <td>{format(new Date(log.timestamp), 'MMM d, yyyy HH:mm:ss')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityLogs;
